import type { ComponentProps } from "react";
import { cn } from "@/lib/utils";

// DESIGN.md "Forma": controls are 38px, the tools above a table 32px. A
// toolbar makes its inputs, selects and buttons the smaller height itself,
// so a page never picks a height by hand.
const TOOLBAR =
  "flex flex-wrap items-end gap-2 [&_[data-slot=input]]:h-control-sm [&_[data-slot=native-select]]:h-control-sm [&_[data-slot=button]]:h-control-sm";

export function Toolbar({ className, ...props }: ComponentProps<"div">) {
  return <div data-slot="toolbar" className={cn(TOOLBAR, className)} {...props} />;
}

/** The same row as a form, for filters that are submitted. */
export function ToolbarForm({ className, ...props }: ComponentProps<"form">) {
  return <form data-slot="toolbar" className={cn(TOOLBAR, className)} {...props} />;
}
